/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

/**
 * Grid data/filter types
 * @module components/Grid/types
 *
 */

const DATE  = ['Date', 'Sent', 'Due']
const MONEY = ['Amount', 'Equivalent', 'Price', 'SGR', 'Negotiated', 'Preferred', 'Total', 'Paid', 'Balance', 'Tax', 'Fee', 'Invoiced', 'Uninvoiced']
const PERCENT = ['Percent']
const QTY = ['Quantity', 'Units']

import Vue from 'vue'
import TextFilter  from './filters/text'
import ListFilter  from './filters/list'
import DateFilter  from './filters/date'
import MoneyFilter from './filters/money'

import Details     from './details'
import ListCell    from './cells/list'
import DateCell    from './cells/date'
import MoneyCell   from './cells/money'
import PercentCell from './cells/percent'
import QtyCell from './cells/qty'

const Types = {
  /**
   *
   */
  details: Vue.extend(Details),

  text: {
    cell: null,
    filter: Vue.extend(TextFilter)
  },

  list: {
    cell: Vue.extend(ListCell),
    filter: Vue.extend(ListFilter)
  },

  date: {
    cell: Vue.extend(DateCell),
    filter: Vue.extend(DateFilter),
    width: 80
  },

  money: {
    type: 'amount',
    column: 'Currency',
    cell: Vue.extend(MoneyCell),
    filter: Vue.extend(MoneyFilter)
  },

  percent: {
    type: 'amount',
    cell: Vue.extend(PercentCell),
    filter: Vue.extend(TextFilter)
  },

  qty: {
    type: 'amount',
    cell: Vue.extend(QtyCell),
    filter: Vue.extend(TextFilter)
  }
}

Types.parseType = (column, key) => {
  return parseColumnType(column, key)
}

export default Types

//
function isType(text, values, additional) {
  let len = values.length
  for (var i = len; i--;) {
    if (text && ~text.indexOf(values[i]) || ~(additional || '').indexOf(values[i].toLowerCase())) return true
  }
}

function parseColumnType(column, key) {
  if (column.type) {
    switch (column.type) {
      case utils.constants.columnType.List:
        return Types.list

      case utils.constants.columnType.Date:
        return Types.date

      case utils.constants.columnType.Money:
        return Types.money

      case utils.constants.columnType.Percent:
        return Types.percent

      case utils.constants.columnType.Qty:
        return Types.qty

      case utils.constants.columnType.Text:
        return Types.text

      default:
        return Types.text
    }
  } else {
    return getColumnTypeBasedOnColumnName(column, key)
  }
}

function getColumnTypeBasedOnColumnName(column, key) {
  const name = column.label || column

  // LIST
  if (column.source) return Types.list

  // DATE
  if (isType(name, DATE)) return Types.date

  // MONEY
  if (isType(name, MONEY, key)) return Types.money

  // PERCENT
  if (isType(name, PERCENT)) return Types.percent

  // QTY
  if (isType(name, QTY)) return Types.qty

  // default
  return Types.text
}



// WEBPACK FOOTER //
// ./src/components/Grid/data-types.js